<template>
    <div class="settings">
        <div class="container-title">
            <div class="left">
                <h2 class="title">{{ $t('dash.settings.title') }}</h2>
            </div>
        </div>

        <div class="navigation">
            <router-link to="/dash/settings/account">
                <div :class="{ btn: true, account : true, active: ongletOpen === 'account' }">{{ $t('dash.settings.nav.account') }}</div>
            </router-link>

            <router-link to="/dash/settings/notifications">
                <div :class="{ btn: true, notifications : true, active: ongletOpen === 'notifications' }">{{ $t('dash.settings.nav.notifications') }}</div>
            </router-link>

            <router-link to="/dash/settings/users">
                <div :class="{ btn: true, users : true, active: ongletOpen === 'users' }">{{ $t('dash.settings.nav.manage_users') }}</div>
            </router-link>

            <router-link to="/dash/settings/billing" v-if="infoUser.admin">
                <div :class="{ btn: true, billing : true, active: ongletOpen === 'billing' }">{{ $t('dash.settings.nav.billing') }}</div>
            </router-link>

            <div class="btn advanced-select" :class="{ active: isAdvancedTab, open: advancedMenuOpen }" v-click-outside="closeAdvancedMenu">
                <div class="advanced-trigger" @click="toggleAdvancedMenu">
                    {{ advancedTabLabel }}
                    <i class="fa-solid fa-chevron-down"></i>
                </div>
                <div
                    class="advanced-dropdown"
                    v-if="advancedMenuOpen"
                    :style="{ top: advancedMenuPosition.top + 'px', left: advancedMenuPosition.left + 'px' }"
                    @click="closeAdvancedMenu"
                >
                    <router-link to="/dash/settings/variables" class="advanced-option" :class="{ active: ongletOpen === 'variables' }">{{ $t('dash.settings.nav.variables') }}</router-link>
                    <router-link to="/dash/settings/api_keys" v-if="canAccessMcp()" class="advanced-option" :class="{ active: ongletOpen === 'api_keys' }">{{ $t('dash.settings.nav.api_keys') }}</router-link>
                    <router-link to="/dash/settings/templates" v-if="!isProd()" class="advanced-option" :class="{ active: ongletOpen === 'templates' }">{{ $t('dash.settings.nav.templates') }}</router-link>
                </div>
            </div>

        </div>

        <div class="content-section-settings">
            <account v-if="ongletOpen=='account'" :infoUser="infoUser" :infoAccount="infoAccount" :updateInfoUser="updateInfoUser" :updateInfoAccount="updateInfoAccount"></account>
            <billing v-if="ongletOpen=='billing' && infoUser.admin" :infoUser="infoUser" :infoAccount="infoAccount" :updateInfoAccount="updateInfoAccount" :allPages="allPages"></billing>
            <notifications v-if="ongletOpen=='notifications'" :infoUser="infoUser" :updateInfoUser="updateInfoUser"></notifications>
            <users v-if="ongletOpen=='users'" :pages_access="Array.isArray(allPages) ? (infoUser.admin ? allPages : allPages.filter(page => infoUser.pages_access.includes(page.id))) : []" :groups="groups" :infoUser="infoUser"></users>
            <variables v-if="ongletOpen=='variables'" :allPages="Array.isArray(allPages) ? allPages : []"></variables>
            <api-keys v-if="ongletOpen=='api_keys' && canAccessMcp()" :allPages="Array.isArray(allPages) ? allPages : []" :infoUser="infoUser"></api-keys>
            <mcp-documentation v-if="ongletOpen=='mcp_docs' && canAccessMcp()"></mcp-documentation>
            <templates-management v-if="ongletOpen=='templates' && !isProd()"></templates-management>
        </div>
    </div>
</template>

<script>
//component
import account from './../settings/account.vue'
import billing from './../settings/billing.vue'
import notifications from './../settings/notifications.vue'
import users from './../settings/users.vue'
import variables from './../settings/variables.vue'
import apiKeys from './../settings/api-keys.vue'
import mcpDocumentation from './../settings/mcp-documentation.vue'
import templatesManagement from './../templates/TemplatesManagement.vue'

//mixins
import SettingsMixins from '../../mixins/Settings.vue'
import UserMixins from '../../mixins/User.vue'
import PagesMixins from '../../mixins/Pages.vue'
import GroupsMixins from '../../mixins/Groups.vue'

import { EventBus } from '@/event-bus';
import ClickOutside from 'vue-click-outside'

export default {
    name: 'settings',

    directives: { ClickOutside },

    components : {
        account,
        billing,
        notifications,
        users,
        variables,
        'api-keys': apiKeys,
        'mcp-documentation': mcpDocumentation,
        'templates-management': templatesManagement
    },

    mixins : [SettingsMixins,UserMixins,PagesMixins,GroupsMixins],

    data() {
        // 'templates' only ever a valid tab outside prod - matches api_keys/mcp_docs just below
        const allowedTabs = ['account','billing','notifications','users','variables','api_keys','mcp_docs']
        if (!this.isProd()) allowedTabs.push('templates')

        return {
            ongletOpen : allowedTabs.includes(this.$route.params.tab) ? this.$route.params.tab : 'account',
            infoUser : {},
            infoAccount :{},
            allPages:{},
            groups: {},
            advancedMenuOpen: false,
            advancedMenuPosition: { top: 0, left: 0 }
        };
    },

    async mounted() {
      this.infoUser = JSON.parse(localStorage.user) || {};

      this.readAccount(this.infoUser.account).then(res => {
        this.infoAccount = res.body.account;
      })

      let getPages = this.infoUser.admin ? this.getAllPages : this.getPages
           
      // this.getPages().then(res => { //task clement a verifier avec aimine si il y a besoin de redemander les pages 
      getPages().then(res => { //task clement a verifier avec aimine si il y a besoin de redemander les pages 
          const { pages } = res.body
          this.allPages = pages
          // localStorage.setItem('pages', JSON.stringify(pages))
      })
      
      this.infoUser = await this.fetchUserInfo();

      this.getGroups().then(res => {
        this.groups = res
        if(!this.infoUser.admin){
          this.groups = this.groups.filter(g => g.pages.find(pageId => this.infoUser.pages_access.includes(pageId)))
        }
      })

    },

    

    watch : {
        '$route.params.tab': function (newTab, oldTab) {
            const allowedTabs = ['account','billing','notifications','users','variables','api_keys','mcp_docs']
            if (!this.isProd()) allowedTabs.push('templates')
            this.ongletOpen = allowedTabs.includes(this.$route.params.tab) ? this.$route.params.tab : 'account';
        }
    },

    computed: {
        // Variables/Clés API/Modèles grouped under one "Avancés" tab instead of 3 separate ones -
        // the top nav was getting crowded as templates/api_keys were added on top of the original
        // account/notifications/users/billing set.
        isAdvancedTab() {
            return ['variables', 'api_keys', 'templates'].includes(this.ongletOpen)
        },

        // shows whichever of the 3 is currently active in place of the generic "Avancés" label -
        // "Avancés" itself is never one of the dropdown's own options, only this fallback.
        advancedTabLabel() {
            if (this.ongletOpen === 'variables') return this.$t('dash.settings.nav.variables')
            if (this.ongletOpen === 'api_keys') return this.$t('dash.settings.nav.api_keys')
            if (this.ongletOpen === 'templates') return this.$t('dash.settings.nav.templates')
            return this.$t('dash.settings.nav.advanced')
        }
    },

    methods: {
        changeOnglet(ongletName){
            this.ongletOpen = ongletName;
        },

        closeAdvancedMenu() {
            this.advancedMenuOpen = false
        },

        // position:fixed (not absolute) and computed here from the trigger's own screen position -
        // .navigation needs overflow-x:auto for its own horizontal tab scrolling on narrow
        // screens, and per the CSS spec that forces overflow-y to also compute as "auto" even when
        // explicitly set to "visible", clipping any absolutely-positioned dropdown that would
        // otherwise overflow it vertically. Fixed positioning escapes that entirely.
        toggleAdvancedMenu(event) {
            if (this.advancedMenuOpen) {
                this.advancedMenuOpen = false
                return
            }
            const rect = event.currentTarget.getBoundingClientRect()
            this.advancedMenuPosition = { top: rect.bottom + 6, left: rect.left }
            this.advancedMenuOpen = true
        },

        // Same check used throughout the app (e.g. section/Pages.vue) - the "Clés API" tab
        // (serveur MCP) is still sandbox-only for now, hidden in production even though the
        // code ships there, until the MCP server itself is deployed to production too.
        isProd() {
            return process.env.VUE_APP_API_HOST === 'https://api.saas.mashup-web.com'
        },

        // mashup-web staff can access the MCP tabs even in prod (ahead of general availability)
        // to validate the integration end-to-end and build the test material needed to submit it
        // to Claude/ChatGPT's connector directories - everyone else stays gated by isProd() as
        // before. Centralized here instead of repeating `infoUser.admin && !isProd()` at each
        // call site so all 3 (nav link + the 2 content blocks) can never drift apart.
        isMashupStaffEmail() {
            return !!(this.infoUser.email && this.infoUser.email.toLowerCase().includes('@mashup-web.com'))
        },

        canAccessMcp() {
            return this.infoUser.admin && (!this.isProd() || this.isMashupStaffEmail())
        },


        refreshInfoUser() {
          if(localStorage.user){
            this.infoUser = JSON.parse(localStorage.user)
          }   
        },

        async updateInfoUser(data) {
         
          try {
            const res = await this.updateUser(data);
           
            const { success, user } = res.body;

            if (success !== true || 'error' in res.body) {
              alert("error updateUser");
              return false;
            }
            this.infoUser = user;
            localStorage.setItem('user', JSON.stringify(user));
            EventBus.$emit("handlerRefreshUser")
            return true;
          } catch (error) {
            alert("error updateUser");
            return false;
          }
        },

        async updateInfoAccount(data) {
          console.log("updateInfoAccount",data)
          try {
            const res = await this.updateAccount(data);
            console.log("response")
            const { success, account  } = res.body;

            if (success !== true || 'error' in res.body) {
              alert("error updateAccount");
              return false;
            }
            this.infoAccount = account;
            return true;
          } catch (error) {
            alert("error updateAccount");
            return false;
          }
        }


    },

    


   


   
};
</script>

<style lang="scss" scoped>

</style>